import {gql} from '@apollo/client'

export const UPDATE_ACCOUNTS = gql`
  mutation UpdateAccounts(
    $accountIds: [String!]!
    $state: String
    $warnWhenOverdue: Boolean
    $useRunningBalanceInvoices: Boolean
    $groups: JSON
  ) {
    accounts(
      accountIds: $accountIds
      state: $state
      warnWhenOverdue: $warnWhenOverdue
      useRunningBalanceInvoices: $useRunningBalanceInvoices
      groups: $groups
    ) {
      collection {
        id
        warnWhenOverdue
        useRunningBalanceInvoices
        state
        groups {
          id
          colour
          name
        }
        balance
      }
    }
  }
`

export const RECALCULATE_ACCOUNTS = gql`
  mutation RecalculateAccounts($accountIds: [String!]!) {
    accounts: recalculateAccounts(accountIds: $accountIds) {
      collection {
        id
        balance
        overdueSince
        overdueAmount
      }
    }
  }
`

export const MERGE_ACCOUNTS = gql`
  mutation MergeAccounts($accountIds: [String!]!) {
    accounts: mergeAccounts(accountIds: $accountIds) {
      id
    }
  }
`

export const GET_ACCOUNTS = gql`
  query GetAccounts(
    $q: String
    $state: String
    $bounds: String
    $page: Int
    $limit: Int
    $sortBy: String
    $sortDirection: String
    $includeGroupIds: [String!]
    $excludeGroupIds: [String!]
    $dashboard: String
    $referredById: String
  ) {
    accounts(
      q: $q
      state: $state
      bounds: $bounds
      page: $page
      limit: $limit
      sortBy: $sortBy
      sortDirection: $sortDirection
      includeGroupIds: $includeGroupIds
      excludeGroupIds: $excludeGroupIds
      dashboard: $dashboard
      referredById: $referredById
    ) {
      collection {
        id
        name
        displayName @client
        contactFullName @client
        contactFirstName
        contactLastName
        contactAddress
        contactEmail
        contactPhone
        customerNumber
        balance
        createdAt
        updatedAt
        groups {
          id
          colour
          name
        }
        state
        xeroLink
        warnWhenOverdue
        useRunningBalanceInvoices
        lastTransactionDate
        overdueSince
        overdueAmount
        numOfAlerts
        numOfActiveServices
        numOfInactiveServices
        numOfActiveRepeatingInvoices
      }
      metadata {
        totalCount
      }
    }
  }
`
